import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '../../../hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref, onMounted } from 'vue';
import dayjs from 'dayjs';
import { AIBEANCHANGESOURCEE, AiBeanRecordAdminVo } from '../../../api/api';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

// 表格列

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));

// 表格引用
const tableRef = ref<any>();

// 初始化列配置
const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'phone',
      label: '手机号',
      type: 'string',
      isCondition: true,
      rule: [
        { required: true, message: '请输入手机号' },
        { pattern: /^1[3-9]\d{9}$/u, message: '请输入正确的手机号格式' },
      ],
      width: 140,
    },
    {
      name: 'changeCount',
      label: '变更数量',
      type: 'number',
      rule: [{ required: true, message: '请输入变更数量' }],
      width: 120,
    },
    {
      name: 'changeSource',
      label: '变更来源',
      type: 'select',
      isCondition: true,
      options: [
        { label: '系统调整', value: AIBEANCHANGESOURCEE.System },
        { label: '充值', value: AIBEANCHANGESOURCEE.Recharge },
        { label: '点券', value: AIBEANCHANGESOURCEE.Ticket },
        { label: '激励', value: AIBEANCHANGESOURCEE.Incentive },
        { label: '查询', value: AIBEANCHANGESOURCEE.Query },
        { label: '店铺客户查询', value: AIBEANCHANGESOURCEE.StoreCustomerQuery },
      ],
      rule: [{ required: true, message: '请选择变更来源' }],
      width: 140,
    },
    {
      name: 'meta',
      label: '详细数据',
      type: 'string',
      width: 180,
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      width: 180,
      hideEdit: true,
      hideCreate: true,
    },
  ]);
});

// 添加和查询初始值
const addInitValue = {
  // 默认值
};

const conditionsInitValue = {
  // 搜索条件默认值
};

// 加载状态
const loading = ref(false);

// 获取数据
const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    // 处理过滤条件，移除空值
    const conditions = Object.entries(filter.conditions).reduce((acc, [key, val]) => {
      if (val !== null && val !== undefined && val !== '') {
        acc[key] = val;
      }
      return acc;
    }, {} as Record<string, any>);

    const res = await useApi().aiBeanRecordApi.pageAiBeanRecordaiBeanRecord({
      conditions,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data?.data?.total || 0,
      data: res.data?.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

// 格式化删除确认信息
const formatDeleteInfo = (row: any) => `确定要删除该AI豆流水记录吗？手机号: ${row.phone || '未知'}, 变更数量: ${row.changeCount || 0}`;

// 添加AI豆流水记录
const addFun = useBaseAsync(async(data: any) => {
  await useApi().aiBeanRecordApi.addAiBeanRecordaiBeanRecord({
    aiBeanRecordVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

// 更新AI豆流水记录
const updateFun = useBaseAsync(async(data: any) => {
  await useApi().aiBeanRecordApi.updateAiBeanRecordaiBeanRecord({
    aiBeanRecordVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

// 删除AI豆流水记录
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().aiBeanRecordApi.deleteAiBeanRecordaiBeanRecord(data.id);
  ElMessage.success('删除成功');
});

// 页面初始化
init();

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "export-file-name": "AI豆流水管理",
      title: "AI豆流水管理",
      paginations: { pageSize: 10 },
      columns: columns.value,
      "get-data": _unref(getData),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "loading"])
  ]))
}
}

})